/**
 * Scrolling Promotion (Marquee Ribbon) - Sleek Theme OS 2.0
 */
if (!customElements.get('scrolling-promotion')) {
  customElements.define(
    'scrolling-promotion',
    class ScrollingPromotion extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        const speed = this.dataset.speed || 28;
        this.style.setProperty('--marquee-speed', `${speed}s`);
      }
    }
  );
}
